import { Grid } from '@material-ui/core'
import React, { FC } from 'react'

//* components
import Button from '../button'
import Typography from '../typography'
import WrapperImage from '../wrapperImage'

//* utils
import ImgUtil from '../../../utils/img.utils'
import { getResourceData } from './util'

type Props = {
  resourceTabsData: any
  allTabData: any
}

export const ResourceTabContent: FC<Props> = ({ resourceTabsData, allTabData }) => {
  return (
    <div className="ResourceTabs__All-Content" id={`Resource-Tabs-Content--${resourceTabsData.id}`}>
      {allTabData.map((tab: any, idx: number) => {
        let prefix = `tab${idx + 1}`

        //* primary
        let robot = tab[`${prefix}Robot`] || ''
        let robotAlt = tab[`${prefix}RobotAlt`] || ''
        let primary = tab[`${prefix}Primary`] || ''
        let primaryResourceData = getResourceData(primary)

        //* secondary
        let secondary = tab[`${prefix}Secondary`] || []
        let active = idx === 0 ? ' active' : ''

        return (
          <div className={'ResourceTabs__Content-Container' + active} key={idx}>
            {/* Primary Section */}
            <Grid container spacing={2} className="ResourceTabs__Content--Top">
              <Grid item sm={4} md={3}>
                {primaryResourceData.category && (
                  <Typography type="captionAlt">{primaryResourceData.category}</Typography>
                )}

                {primaryResourceData.title && (
                  <Typography type="header3">{primaryResourceData.title}</Typography>
                )}

                {primaryResourceData.url1 && (
                  <Button
                    icon={true}
                    href={primaryResourceData.url1}
                    text={primaryResourceData.ctaText}
                    type="text-link"
                    size="small"
                    theme={'dark'}
                  />
                )}
              </Grid>

              {primaryResourceData.image && (
                <Grid item xs={12} sm={8} md={7} className="ResourceTabs__Image-Container">
                  <WrapperImage
                    src={ImgUtil.getResizedImageUrl(primaryResourceData.image, '')}
                    alt={primaryResourceData.imageAlt}
                    width={564}
                    height={282}
                    threshold={650}
                  />
                </Grid>
              )}

              {robot && (
                <Grid item xs={2} className="ResourceTabs__Robot-Container">
                  <WrapperImage
                    src={ImgUtil.getResizedImageUrl(robot, '')}
                    alt={robotAlt}
                    threshold={650}
                  />
                </Grid>
              )}
            </Grid>

            {/* Secondary Section */}
            <Grid container spacing={2} className="ResourceTabs__Content--Bottom">
              {secondary.map((tab: any, idx: number) => {
                let data = getResourceData(tab)

                return (
                  <Grid item xs={12} sm={3} key={idx}>
                    {data.category && <Typography type="captionAlt">{data.category}</Typography>}
                    {data.title && <Typography type="header6">{data.title}</Typography>}
                    {data.url1 && (
                      <Button
                        icon={true}
                        href={data.url1}
                        text={data.ctaText}
                        type="text-link"
                        size="small"
                        theme={'dark'}
                      />
                    )}
                  </Grid>
                )
              })}
            </Grid>
          </div>
        )
      })}
    </div>
  )
}
